// ----------------------------------------------------------------------

const ROOTS = {
  AUTH: "/auth",
  DASHBOARD: "/dashboard",
  USER: "/users",
  FEEDBACK: "/feedbacks",
  CHANGE_PASSWORD: "change-password",
};

// ----------------------------------------------------------------------

export const paths = {
  auth: {
    jwt: {
      signIn: `login`,
    },
  },
  // DASHBOARD
  dashboard: {
    root: ROOTS.DASHBOARD,
    user: ROOTS.USER,
    feedback: ROOTS.FEEDBACK,
    changePassword: ROOTS.CHANGE_PASSWORD,
  },
};
